<template>
  <Header v-if="general" />
  <div id="pageContent">
    <router-view :key="route.fullPath" />
  </div>
  <Footer v-if="general" />
</template>
<script setup>
import '@/scss/index.scss';
import Footer from './components/layout/Footer.vue';
import Header from './components/layout/Header.vue';

import { useRoute } from 'vue-router';

const route = useRoute();
</script>
<script>
export default {
  computed: {
    locale() {
      return this.$route.params.locale || 'de';
    }
  },
  watch: {
    locale: {
      handler(to) {
        this.$CookieConsent.setLanguage(to, true)
      },
      immediate: true
    }
  }
};
</script>
<style lang="scss">
:root {
  --volt: $volt;
}
</style>
